// extracted by mini-css-extract-plugin
export default {"formBackground":"ResetPassword_formBackground__GUHCY","duploLogoOpaque":"ResetPassword_duploLogoOpaque__c14U2"};